import * as React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {Box,Typography} from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme,styled} from '@mui/material/styles'
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import ReactPlayer from 'react-player'
import { ArrowDropDownCircleOutlined, Remove, RemoveCircle} from '@mui/icons-material';
import ContentView from './ContentView';

const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={4} square {...props} />
))(({ theme }) => ({
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
	borderRadius:10,
	background:"black",
	margin:5
}));

const AccordionSummary = styled((props) => (
<MuiAccordionSummary
	expandIcon={<ArrowDropDownCircleOutlined sx={{ fontSize: 30 }} />}
	{...props}
/>
))(({ theme }) => ({
	background:theme.palette.mode === 'dark'? 'black': 'white',
	flexDirection: 'row',
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
	}
}));
	
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	background:theme.palette.mode === 'dark'? 'black' : 'white',
}));

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 7,
    backgroundColor: '#100101'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 5
  },
  minHeight:50,
  maxHeight:150,
  marginBottom:2,
  justifyContent:"center",
  alignItems:"center",
  borderRadius: 10
}),

);


const SectionContent = ({visible,setVisible,data,setData})=>{

const theme = useTheme()
const [expanded, setExpanded] = React.useState(true);
const dispatch = useDispatch()

const onClose = () => {
	setVisible(false);
};

const handleChange = () => (event, newExpanded) => {
	setExpanded(newExpanded ? true : false);
};

return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<MenuIcon/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Section Content
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{minWidth:{xs:300,md:400},justifyContent:"center",background:theme.palette.background.default}}>
			{
				data?.length == 0 && (
					<Box>
						<Typography m={1} style={{fontSize:15,fontWeight:400,color:"gold"}}>
							There isn't any questions
						</Typography>
					</Box>
				)
			}
			{
				data?.map((item,index)=>{
					return(
						<Box key={index}>
							<Accordion key={index} sx={{width:{xs:"100%",md:"95%"},marginLeft:1}} expanded={expanded} onChange={handleChange(true)}>
								<AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
									<Box sx={{justifyContent:"space-between",alignItems:"center",textAlign:"left"}}>
										<IconButton onClick={(e)=>{
												e.preventDefault()
												setData(data?.filter(itm=>itm?.title !== item?.title))
											}}>
												<RemoveCircle sx={{color:"red"}}/>
										</IconButton>
										<ContentView title={`${index+1}. Question`} content={item?.question}/>
									</Box>
								</AccordionSummary>
								<AccordionDetails sx={{justifyContent:"center",alignItems:"center",mb:1}}>
									<ContainerBox>
										{
											item?.hasImage && (
												<img resizemode="cover" src={item?.imageUrl} width={100} height={100} style={{borderRadius:5}}/>
											)
										}
										{
											item?.hasAudio && (
												<audio src={item?.audioUrl} controls style={{width:"95%",height:40}}/>
											)
										}
										{
											item?.hasVideo && (
												<video src={item?.videoUrl} controls style={{borderRadius:5,width:"95%",height:150}}/>
											)
										}
										<ContentView title="Question type" content={item?.question_type}/>
										{
											item?.responses?.map((itm,index)=>(
												<ContentView key={index} title={`${index+1}# Response `} content={itm}/>
											))
										}	
									</ContainerBox>							
								</AccordionDetails>
							</Accordion>
						</Box>
					)
				})
			}
		</DialogContent>
	</Dialog>
	)
}

export default SectionContent